import { Box, Container, Typography } from "@mui/material";
import barbieriMarca from "../assets/images/logo_footer.svg";
import colores from "../shared/constant/styles";

const FooterPage = () => {
  return (
    <Box
      component="footer"
      sx={{ backgroundColor: colores.azulOscuro, color: "white", py: 5, px: 2 }}
    >
      <Container maxWidth="lg">
        <div style={{ textAlign: "center" }}>
          <img
            src={barbieriMarca}
            alt="Barbieri"
            style={{ width: 200, height: 80, marginBottom: 15 }}
          />
        </div>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.5,
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontWeight: "bold", fontSize: 20, fontFamily: "Stag" }}
          >
            ¿Tenés dudas?
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.5,
            marginTop: 2,
          }}
        >
          <Typography sx={{ fontSize: 16 }}>
            Escribinos a tiendadigital@adbarbieri.com o por WhatsApp a{" "}
            <b>+54 11 2373-5928</b>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default FooterPage;
